import { createSlice } from '@reduxjs/toolkit';
import { getFeatureFlags } from '../api/featureFlags';

const slice = createSlice({
	name: 'featureFlags',
	initialState: {
		data: {
			flags: {},
		},
	},
	reducers: {
		featureFlagsReceived: (featureFlags, action) => {
			featureFlags.data.flags = action.payload.flags;
		},
	},
});

export const { featureFlagsReceived } = slice.actions;

export default slice.reducer;

const toFlagMap = (featuresOrToggles = []) => {
	return featuresOrToggles.reduce((flags, feature) => {
		if (feature?.name) {
			flags[feature.name] = feature.enabled === true;
		}

		return flags;
	}, {});
};

export const loadFeatureFlags = () => async (dispatch) => {
	try {
		const response = await getFeatureFlags();
		const payload = response.data;
		const flags = payload?.features || [];

		dispatch({
			type: featureFlagsReceived.type,
			payload: {
				flags: toFlagMap(flags),
			},
		});
	} catch (error) {
		if (error?.response?.status === 401) return;
		console.warn('Failed to load feature flags', error);
	}
};
